export default __webpack_public_path__ + "static/media/typicalweek (4).6ec694a5.png";